<script setup lang="ts">
import { useAttrs } from 'vue';
defineOptions({ inheritAttrs: false, name: 'EGS_Fieldset' });
withDefaults(defineProps<{ legend?: string }>(), { legend: '' });
const attrs = useAttrs();
</script>
<template>
	<fieldset v-bind="attrs" :class="['rounded-xl border border-surface bg-[var(--egs-content-background)] px-4 pb-4', attrs['class']]">
		<legend class="px-2 text-sm font-semibold text-color">
			<slot name="legend">{{ legend }}</slot>
		</legend>
		<slot />
	</fieldset>
</template>
